export default __webpack_public_path__ + "static/media/closeIcon.c7cd5093.svg";